import './App.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { useState, useEffect } from 'react';
import Home from './components/Home';
import Projects from './components/Projects';
import LocalLinks from './components/LocalLinks';
import User from './components/User';
import Settings from './components/Settings';
import About from './components/About';
import { useSelector, useDispatch } from 'react-redux';
import { setDark, setLang, setTheme } from './store/actions';

function App() {
	// default state
	const [state, setState] = useState('home');

	const { theme, lang, dark } = useSelector((s) => s);
	const dispatch = useDispatch();

	const translations = {
		rus: {
			user: {
				btndesc: 'Немного обо мне',
				infolist: [
					"Fullstack web-разработчик",
					"btw i use arch",
					"DM: dwmflc",
					"Codeberg: KatsukiAmatsuyu",
					"Терпеть не могу Windows",
					"Обожаю Linux и открытое ПО",
				]
			},
			about: {
				btntext: 'Об этой странице'
			},
			header: 'Добро пожаловать ко мне на страницу :)',
			options: {
				settings: {
					uppertext: 'Настройки',
					addtext: 'Есть темная тема! WOW!'
				},
				projects: 'Проекты',
				locallinks: 'Ссылки',
			},
			hometext: 'Пожалуйста, выберете одну из опций',
			swlangbtn: 'Переключение языка',
			settings: {
				categories: {
					appearance: 'Внешний вид',
					language: 'Язык'
				},
				options: {
					darkmode: {
						header: 'Темная тема',
						light: 'Светлая тема',
						dark: 'Темная тема'
					},
					colorscheme: {
						bluish: 'Bluish'
					},
					language: {
						header: 'Язык интерфейса',
						eng: 'English',
						rus: 'Русский'
					}
				}
			},
		},
		eng: {
			user: {
				btndesc: 'Something about me',
				infolist: [
					"Fullstack web-developer",
					"btw i use arch",
					"DM: dwmflc",
					"Codeberg: KatsukiAmatsuyu",
					"Windows hater",
					"In love with Linux and OSS",
				]
			},
			about: {
				btntext: 'About this page'
			},
			header: 'Welcome to my page :)',
			options: {
				settings: {
					uppertext: 'Settings',
					addtext: 'You can make this dark'
				},
				projects: 'Projects',
				locallinks: 'Local links',
			},
			hometext: 'Please choose option on the right',
			swlangbtn: 'Language switch',
			settings: {
				categories: {
					appearance: 'Appearance',
					language: 'Language'
				},
				options: {
					darkmode: {
						header: 'Dark mode',
						light: 'Light mode',
						dark: 'Dark mode'
					},
					colorscheme: {
						bluish: 'Bluish'
					},
					language: {
						header: 'Language',
						eng: 'English',
						rus: 'Русский'
					}
				}
			}
		}
	}

	const [dict, setDict] = useState(translations.rus);

	useEffect(() => {
		const l = localStorage.getItem("lang") || "rus";
		const t = localStorage.getItem("indtheme") || "bluish";
		const d = localStorage.getItem("dark") === 'true' || false;

		dispatch(setDark(d));
		dispatch(setTheme(t));
		dispatch(setLang(l));
		switch (l) {
			case 'rus':
				setDict(translations.rus);
				break
			case 'eng':
				setDict(translations.eng);
				break
		}
	}, []);

	return (
		<div className={`App ${theme} ${dark ? "dark" : "light"}`} id="rootdiv">
			<div className="container">
				<div className="container__leftside">
					<div className="container__leftside__header">{dict.header}</div>
					<div className="container__leftside__firstbtns">
						<div className="container__leftside__user" onClick={() => setState('user')}>
							<div className="container__leftside__user__pic">
								<div className="dummdivvv"></div>
							</div>
							<div className="container__leftsife__user__info">
								<div className="container__leftside__user__info__name">Katsuki Amatsuyu</div>
								<div className="container__leftside__user__info__btndesc">{dict.user.btndesc}</div>
							</div>
							<div className="entranceind">
								<FontAwesomeIcon icon={faChevronRight} className="entranceind__icon" />
							</div>
						</div>
						<div className="container__leftside__firstbtns__about" onClick={() => setState('about')}>
							{dict.about.btntext}
							<div className="entranceind">
								<FontAwesomeIcon icon={faChevronRight} className="entranceind__icon" />
							</div>
						</div>
					</div>
					<div className="container__leftside__options">
						<div className="container__leftside__options__entry settingsbtn" onClick={() => setState('settings')}>
							<div className="settingsbtn__uppertext">{dict.options.settings.uppertext}</div>
							<div className="settingsbtn__desc">{dict.options.settings.addtext}</div>
							<div className="entranceind">
								<FontAwesomeIcon icon={faChevronRight} className="entranceind__icon" />
							</div>
						</div>
						<div className="container__leftside__options__entry" onClick={() => setState('projects')}>
							{dict.options.projects}
							<div className="entranceind">
								<FontAwesomeIcon icon={faChevronRight} className="entranceind__icon" />
							</div>
						</div>
						<div className="container__leftside__options__entry" onClick={() => setState('locallinks')}>
							{dict.options.locallinks}
							<div className="entranceind">
								<FontAwesomeIcon icon={faChevronRight} className="entranceind__icon" />
							</div>
						</div>
					</div>
				</div>
				<div className={['projects', 'locallinks', 'user', 'settings', 'about'].includes(state) ? "container__rightside opened" : "container__rightside"}>
					{state === 'home' && <Home dict={dict} />}
					{state === 'projects' && <Projects dict={dict} setState={setState} />}
					{state === 'locallinks' && <LocalLinks dict={dict} setState={setState} />}
					{state === 'user' && <User dict={dict} setState={setState} />}
					{state === 'settings' && <Settings dict={dict} setDict={setDict} translations={translations} setState={setState} />}
					{state === 'about' && <About dict={dict} setState={setState} />}
				</div>
			</div>
		</div>
	);
}

export default App;
